<template>
  <v-container>
    <div>
      <template>
        <v-dialog
          v-model="dialog"
          width="600"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Create Additional Identification Method
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text">
              <v-row class="mt-5">
                <v-col cols="12">
                  <label class="">Name</label>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    placeholder="Select Name"
                    v-model="name"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-card-actions class="mt-10" style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn
                  @click="closeModal"
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  @click="submit"
                  right
                  height="44"
                  color="primary"
                  class="px-5"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";

import gql from "graphql-tag";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      name: "",
    };
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    async submit() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation createAdditionalIdentificationMethod(
              $createAdditionalIdentificationMethodInput: CreateAdditionalIdentificationMethodInput!
            ) {
              createAdditionalIdentificationMethod(
                createAdditionalIdentificationMethodInput: $createAdditionalIdentificationMethodInput
              ) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            createAdditionalIdentificationMethodInput: {
              name: this.name,
            },
          },
        })
        .then(response => {
          if (response.data.createAdditionalIdentificationMethod) {
            this.$notify({
              title: "Additional Identification Method Added Successfully",
              text: "", //res.message,
              type: "success",
            });

            this.$emit("identificationMethod:created");
          }
        })
        .catch(() => {
          this.$notify({
            title: "Additional Identification Method Not Added",
            text: "",
            type: "error",
          });
        })
        .finally(() => {
          this.$emit("closeDialog");
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}

.v-tab {
  text-transform: none !important;
}
</style>
